import React from 'react';
import { webshopButtonCss } from 'app/modules/web-shop/components/buttons/style';

interface WebshopButtonProps {
  text: string;
  disabled?: boolean;
}

export const WebshopButton = ({ text, disabled }: WebshopButtonProps) => (
  <button disabled={disabled} type="button" css={webshopButtonCss(disabled)}>
    {text}
  </button>
);
